module.exports = __webpack_public_path__ + "img/jf1.b935fab2.png";